// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/SourceSans-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/SourceSans-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/SourceSans-Semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/SourceSans-Bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'SourceSansPro';
  font-weight: 300;
  font-style: normal;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
}
@font-face {
  font-family: 'Source Sans Pro';
  font-weight: 300;
  font-style: normal;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
}
@font-face {
  font-family: 'SourceSansPro';
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
}
@font-face {
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
}
@font-face {
  font-family: 'SourceSansPro';
  font-weight: 600;
  font-style: normal;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
}
@font-face {
  font-family: 'Source Sans Pro';
  font-weight: 600;
  font-style: normal;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
}
@font-face {
  font-family: 'SourceSansPro';
  font-weight: 700;
  font-style: normal;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
}
@font-face {
  font-family: 'Source Sans Pro';
  font-weight: 700;
  font-style: normal;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
}
`, "",{"version":3,"sources":["webpack://./src/fonts.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2DAAsD;AACxD;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2DAAsD;AACxD;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2DAAwD;AAC1D;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2DAAwD;AAC1D;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2DAAyD;AAC3D;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2DAAyD;AAC3D;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2DAAqD;AACvD;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2DAAqD;AACvD","sourcesContent":["@font-face {\n  font-family: 'SourceSansPro';\n  font-weight: 300;\n  font-style: normal;\n  font-display: auto;\n  src: url('fonts/SourceSans-Light.woff') format('woff');\n}\n@font-face {\n  font-family: 'Source Sans Pro';\n  font-weight: 300;\n  font-style: normal;\n  font-display: auto;\n  src: url('fonts/SourceSans-Light.woff') format('woff');\n}\n@font-face {\n  font-family: 'SourceSansPro';\n  font-weight: 400;\n  font-style: normal;\n  font-display: auto;\n  src: url('fonts/SourceSans-Regular.woff') format('woff');\n}\n@font-face {\n  font-family: 'Source Sans Pro';\n  font-weight: 400;\n  font-style: normal;\n  font-display: auto;\n  src: url('fonts/SourceSans-Regular.woff') format('woff');\n}\n@font-face {\n  font-family: 'SourceSansPro';\n  font-weight: 600;\n  font-style: normal;\n  font-display: auto;\n  src: url('fonts/SourceSans-Semibold.woff') format('woff');\n}\n@font-face {\n  font-family: 'Source Sans Pro';\n  font-weight: 600;\n  font-style: normal;\n  font-display: auto;\n  src: url('fonts/SourceSans-Semibold.woff') format('woff');\n}\n@font-face {\n  font-family: 'SourceSansPro';\n  font-weight: 700;\n  font-style: normal;\n  font-display: auto;\n  src: url('fonts/SourceSans-Bold.woff') format('woff');\n}\n@font-face {\n  font-family: 'Source Sans Pro';\n  font-weight: 700;\n  font-style: normal;\n  font-display: auto;\n  src: url('fonts/SourceSans-Bold.woff') format('woff');\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
